import { useScrollTrigger, Zoom } from "@material-ui/core";
import { scrollStyle } from "../../styles/scrollTop.style";

const ScrollTop = (props) => {
  const { children, window } = props;
  const classes = scrollStyle();
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} className={classes.root}>
        {children}
      </div>
    </Zoom>
  );
};
export default ScrollTop;
